export enum PaymentType {
    PayByCard,
    Tinkoff,
    Split,
    OnlyCard
}